export const VNORDERS_SET_CURRENT_ORDER_UUID = 'VNORDERS_SET_CURRENT_ORDER_UUID'
export const VNORDERS_SET_ORDER = 'VNORDERS_SET_ORDER'
export const VNORDERS_UNSET_ORDER = 'VNORDERS_UNSET_ORDER'
export const VNORDERS_SET_UNSYNCED_ORDER = 'VNORDERS_SET_UNSYNCED_ORDER'
export const VNORDERS_UNSET_UNSYNCED_ORDER = 'VNORDERS_UNSET_UNSYNCED_ORDER'
export const VNORDERS_SET_ORDER_ACTION = 'VNORDERS_SET_ORDER_ACTION'

export const VNORDERS_SET_TEMP_PAYMENT = 'VNORDERS_SET_TEMP_PAYMENT'
